import { render, staticRenderFns } from "./ContractFiles.vue?vue&type=template&id=18a9e145&scoped=true&"
import script from "./ContractFiles.vue?vue&type=script&lang=js&"
export * from "./ContractFiles.vue?vue&type=script&lang=js&"
import style0 from "./ContractFiles.vue?vue&type=style&index=0&id=18a9e145&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a9e145",
  null
  
)

export default component.exports